import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { FormGroup, FormControl, FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ApplicationService, DataService, LookupService } from '../../services';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ToastrService } from 'ngx-toastr';
import { AppConfig } from '../../_config';
import { DaoDialogComponent } from 'src/app/directives';
import { MatDialog } from '@angular/material';
import { FirebaseService } from 'src/app/services/firebase.service';


@Component({
  selector: 'app-otp',
  templateUrl: './otp.component.html',
  styleUrls: ['./otp.component.css']
})
export class OtpComponent implements OnInit {
  @ViewChild("start") MyProp: ElementRef;
  public Lookups: any = [];
  accountAppModel: any = {};
  existing = false;
  existingData:any;
  isDisabled = false;
  options: FormGroup;
  AppNumber: any;
  EmailAddress: any;
  AccountNumber:any;
  otp: any;
  OtpGenerated = false;
  OtpVerified = false;
  OtpVerifiedInOldApp = true;
  Otp = 10;
  accessCode: any;
  isDevEnv = false;
  oldApp = false;
  countStart: any;
  logo = '';
  banner = '';
  mainPage = true;
  hideRequiredControl = new FormControl(false);
  floatLabelControl = new FormControl('auto');
  constructor(private appConfig: AppConfig, fb: FormBuilder, private applicationService: ApplicationService,public firebase:FirebaseService,
    private lookupService: LookupService, private ngxService: NgxUiLoaderService,
    private readonly route: ActivatedRoute, private toastr: ToastrService,
    private readonly router: Router, private dialog: MatDialog) {
    this.logo = appConfig.logoPath;
    this.banner = appConfig.bannerPath;
    this.getSetupDataFromServer();
  }
  ngOnInit() {
    DataService.set('isLanding', false);
    this.MyProp.nativeElement.scrollIntoView({ behavior: "smooth", block: "start" });
    this.route.paramMap.subscribe(params => {
      this.oldApp = this.convertToBoolean(params.get("oldApp"));
      if(this.oldApp){
        DataService.set('IsOld','1');
      }else{
        DataService.set('IsOld','0');
      }
      
      if(this.oldApp==true)
      {
        this.firebase.logEvent('Action | Resuming Old Application');
      }
      else if (this.oldApp==false)
      {
        this.firebase.logEvent('Action | Creating New Application');
      }
    });
  }

  onSelectExisting(data) {
    if (data) {
      this.existing = data.checked;
    }
  }
  getSetupDataFromServer() {
    this.lookupService.getBranchesLookups().subscribe(data => DataService.set('Branches', data));
    this.lookupService.getAllLookups().subscribe(data => DataService.set('Lookups', data));
  }

  searchApp() {
    this.oldApp = true;
  }
  convertToBoolean(input: string): boolean | undefined {
    try {
      return JSON.parse(input);
    }
    catch (e) {
      return undefined;
    }
  }
  async GenerateOtp() {


    const searchRequest = {};
    
    this.ngxService.start();
    if (this.AccountNumber) {
      await this.applicationService.readApplicationByAccountNumber(this.AccountNumber).toPromise().
      then(async resInner => {
        if (resInner && resInner.data != null && resInner.status && resInner.status.code == '200'){
          
          this.existingData = resInner.data;
          this.accountAppModel.AccountTitle = this.existingData.AccountTitle;
          this.accountAppModel.EmailAddress = this.EmailAddress = this.existingData.Email1;
          this.accountAppModel.PrimaryApplicantName = this.existingData.AccountTitle;
          DataService.set("Account",this.existingData);
          DataService.set("RefNo",this.AccountNumber);
          if(this.EmailAddress){
            searchRequest['Email'] = this.EmailAddress;
            await this.applicationService.GetOTP(searchRequest).toPromise().
            then(async res => {
              this.ngxService.stop();
  
              if (res  && res.status && res.status.code == '201') {
                this.firebase.logEvent('Action | OTP Generated');
                console.log(res.status.message);
                //this.router.navigate(['/home']);
                this.OtpGenerated = true;
                this.countStart = this.appConfig.AccessCodeExpiry;
                this.Otp = this.countStart;
                if (this.appConfig.env.toLowerCase() == 'dev') {
                  this.accessCode = res.data;
                  this.isDevEnv = true;
                }
  
              }
  
            }).catch(err => {
              this.ngxService.stop();
              console.log(err);
            });
          }
         

    

          this.ngxService.stop();
          //this.showInfo(this.existingData.IBAN);
        }else{
          this.ngxService.stop();
          this.showError(resInner.status.message);
          this.Otp = 0;
          return true;
        }
        
      }).catch(err =>
        console.log(err));
    }
    else {
      this.ngxService.stop();
    this.showError("Invalid Account Numver, Please try again.");
    this.Otp = 0;
    return true;

    }
    
  }

  async GenerateOtpInOld() {

    this.ngxService.start();
    const searchRequest1 = {};
    searchRequest1['AccountApplicationNumber'] = this.AccountNumber;
    DataService.set("RefNo",this.AccountNumber);
    //searchRequest1['Email'] = this.EmailAddress;
    await this.applicationService.readApplication(searchRequest1).toPromise().
    then(async res => {
      if (res && res.data == null && res.status && res.status.code == '404') {
        console.log(res.status.message);
        this.ngxService.stop();
        this.showError("Application does not exist");
        this.Otp = 0;
        //this.router.navigate(['/home']);
      }
      else if (res && res.data != null && res.status && res.status.code == '200') {
        DataService.set('Account', res.data.TmxCustomerMaster[0]);// this._data.Account = res.data;
        DataService.set('Checklist', res.data.TmxLoanApplicationChecklist);
        DataService.set('data',res.data);
        const searchRequest = {};
        searchRequest['Email'] = this.EmailAddress = res.data.CreatedBy;
        if (this.AccountNumber && this.EmailAddress) {
         
                await this.applicationService.GetOTP(searchRequest).toPromise().
                then(async res => {
                  this.ngxService.stop();
      
                  if (res  && res.status && res.status.code == '201') {
                    this.firebase.logEvent('Action | OTP Generated');
                    console.log(res.status.message);
                    //this.router.navigate(['/home']);
                    this.OtpGenerated = true;
                    this.countStart = this.appConfig.AccessCodeExpiry;
                    this.Otp = this.countStart;
                    if (this.appConfig.env.toLowerCase() == 'dev') {
                      this.accessCode = res.data;
                      this.isDevEnv = true;
                    }
      
                  }
      
                }).catch(err => {
                  this.ngxService.stop();
                  console.log(err);
                });
              
             
    
        
    
              this.ngxService.stop();
              //this.showInfo(this.existingData.IBAN);
           
        }
        else {
          this.ngxService.stop();
        this.showError("Invalid Account Number / Email, Please try again.");
        this.Otp = 0;
        return true;
    
        }
        this.ngxService.stop();
        //this.router.navigate(['/home']);
      }
      else if (res && res.status && res.status.code == '403') {
        this.ngxService.stop();
        this.showInfo("Application is already submitted for further processing. Please contact your branch for details.");

      }
      else {
        this.ngxService.stop();
        if (res && res.status && res.status.message) {
          this.showError(res.status.message);
        } else {
          this.showError('An error occurred while retrieving the application');
        }
      }
    }).catch(err => {
      this.ngxService.stop();
      console.log(err)
    });

   
    
  }

  async VerifyOtpInOld() {

    this.ngxService.start();
    DataService.delete('emailAddress');
    DataService.delete('Account');


    const searchRequest = {};
    searchRequest['Email'] = this.EmailAddress;
    searchRequest['OTP'] = this.otp;
    searchRequest['accountNum'] = this.AccountNumber;

    await this.applicationService.VerifyOTP(searchRequest).toPromise().
      then(async res => {
        if (res && res.data != null && res.status && res.status.code == '200') {
          console.log(res.status.message);
          
          this.firebase.logEvent('Action | OTP Verified');
          DataService.set('emailAddress', this.EmailAddress);
         this.OtpVerifiedInOldApp = true;

        }
        else {
          this.ngxService.stop();
          this.OtpVerifiedInOldApp = false;
          this.showError("Invalid OTP, Please try again.");
          this.Otp = 0;
          return true;
        }

      }).catch(err =>
        console.log(err));
  }

  async VerifyOtp() {

    this.ngxService.start();
    DataService.delete('emailAddress');
    DataService.delete('Account');


    const searchRequest = {};
    searchRequest['Email'] = this.EmailAddress;
    searchRequest['OTP'] = this.otp;
    searchRequest['accountNum'] = this.AccountNumber;

    await this.applicationService.VerifyOTP(searchRequest).toPromise().
      then(async res => {
        if (res && res.data != null && res.status && res.status.code == '200') {
          console.log(res.status.message);
          this.OtpVerified = true;
          this.firebase.logEvent('Action | OTP Verified');
          DataService.set('emailAddress', this.EmailAddress);
         

        }
        else {
          this.ngxService.stop();
          this.showError("Invalid OTP, Please try again.");
          this.Otp = 0;
          return true;
        }

      }).catch(err =>
        console.log(err));
  }
  back() {
    this.oldApp = false;
    this.OtpVerified = false;
    DataService.set('isLanding', true);
    this.router.navigate(['/accountOpening']);
  }
  Proceed(){
    this.router.navigate(['/home']);
  }
  async proceed(data) {
    this.ngxService.start();
    
   

    if (data === true ) {

      const searchRequest = {};
      
      searchRequest['Email'] = this.EmailAddress;
    searchRequest['OTP'] = this.otp;
    searchRequest['accountNum'] = this.AccountNumber;
      await this.applicationService.VerifyOTP(searchRequest).toPromise().
      then(async res => {
        if (res && res.data != null && res.status && res.status.code == '200') {
          console.log(res.status.message);
          
          this.firebase.logEvent('Action | OTP Verified');
          DataService.set('emailAddress', this.EmailAddress);
         this.OtpVerifiedInOldApp = true;
         this.ngxService.stop();
         this.router.navigate(['/home']);
      

        }
        else {
          this.ngxService.stop();
          this.OtpVerifiedInOldApp = false;
          this.showError("Invalid OTP, Please try again.");
          this.Otp = 0;
          return true;
        }

      }).catch(err =>
        console.log(err));


      
    } else {

      const searchRequest = {};
      
      searchRequest['Email'] = this.EmailAddress;
    searchRequest['OTP'] = this.otp;
      await this.applicationService.VerifyOTP(searchRequest).toPromise().
      then(async res => {
        if (res && res.data != null && res.status && res.status.code == '200') {
          console.log(res.status.message);
          
          this.firebase.logEvent('Action | OTP Verified');
          DataService.set('emailAddress', this.EmailAddress);
         this.OtpVerified = true;
         this.ngxService.stop();
         this.router.navigate(['/home']);
         

        }
        else {
          this.ngxService.stop();
          this.OtpVerified = false;
          this.showError("Invalid OTP, Please try again.");
          this.Otp = 0;
          return true;
        }

      }).catch(err =>
        console.log(err));
      
     

    }

  }
  saveit(){
    // the url,html tag should be called from here , how ?
    window.open("../../assets/tnc/calc.xlsx");
    }
  showError(message: string) {
    //this.toastr.error(message);
    this.dialog.open(DaoDialogComponent, {
      data: {
        title: 'Error',
        message: message,
        type: 'error'
      }
    });
  }
  showInfo(message: string) {
    //this.toastr.error(message);
    this.dialog.open(DaoDialogComponent, {
      data: {
        title: 'Information',
        message: message,
        type: 'info'
      }
    });
  }

}
